import { Card, CardBody } from '@repo/ui';
import { TabNavigation, type Tab } from '@xtnd/web/shared/components';
import { useTabParams } from '../../../hooks';
import { ArExceptionSummary } from './ArExceptionSummary';
import { ArPivotTable } from './ArPivotTable';
import { ArInvoiceTable } from './ArInvoiceTable';

const DEFAULT_TAB = 'by-client';

export function ARDashboardView() {
  const { tabParam, handleTabChange } = useTabParams({ defaultTab: DEFAULT_TAB });

  const innerTabs: Tab[] = [
    {
      id: 'by-client',
      label: 'By Client',
      icon: 'HiUsers',
      content: (
        <CardBody className="p-0">
          <ArPivotTable />
        </CardBody>
      ),
    },
    {
      id: 'all-invoices',
      label: 'All Invoices',
      icon: 'HiClipboardList',
      content: (
        <CardBody className="p-0">
          <ArInvoiceTable />
        </CardBody>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      {/* Summary Statistics */}
      <ArExceptionSummary />

      {/* Main Content Tabs */}
      <Card variant="outlined" padding="none">
        {/* Inner Tabs */}
        <div className="border-b border-xtnd-dark-100 dark:border-xtnd-dark-600 px-6 py-4">
          <TabNavigation tabs={innerTabs} activeTab={tabParam} onTabChange={handleTabChange} />
        </div>
      </Card>
    </div>
  );
}
